import classNames from 'classnames';
import React from 'react';
import styles from './basket-amount.scss';

const BasketAmount = ({ basketItems, isBrandPromiseActive }) => (
  <React.Fragment>
    <span
      data-test="basket-amount"
      data-testid="basket-amount"
      className={
        basketItems > 0
          ? classNames(styles.icon, { [styles.icon__bp]: isBrandPromiseActive })
          : styles.visuallyHidden
      }
    >
      {basketItems}
    </span>
    <span className={styles.visuallyHidden}>items in Basket</span>
  </React.Fragment>
);

export default BasketAmount;
